// 弹窗内重新验证本人账号；校验发生在写入新登录态之前。
export function assertInlineBindingScope(context:any, token:unknown, user:any, orgId:unknown, result:any) {
  if (!context) return
  if (context.valid() !== true || String(token || '') !== context.token
      || Number(token ? user?.id || 0 : 0) !== context.id || Number(orgId || 0) !== context.orgId
      || !result?.token || !Number(result.id)
      || (context.id && (Number(result.id) !== context.id || Number(result.orgId) !== Number(user?.orgId)))
      || (context.customer && Number(result.orgId) !== context.orgId)) {
    throw new Error('账号或店铺已发生变化，请重新打开绑定窗口验证')
  }
}
